module.exports = __webpack_public_path__ + "img/map-firstfinancial.fc42305e.png";